(function (global) {
  function partsForLondon(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).formatToParts(date);
    var values = { hour: 0, minute: 0, second: 0 };
    parts.forEach(function (part) {
      if (Object.prototype.hasOwnProperty.call(values, part.type)) {
        values[part.type] = parseInt(part.value, 10);
      }
    });
    values.hour = values.hour % 24;
    return values;
  }

  function secondsToLondonMidnight(date) {
    var values = partsForLondon(date || new Date());
    return 86400 - (values.hour * 3600 + values.minute * 60 + values.second);
  }

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function countdownLabel(seconds) {
    return pad(Math.floor(seconds / 3600)) + ' : ' + pad(Math.floor((seconds % 3600) / 60)) + ' : ' + pad(seconds % 60);
  }

  function initAdvertorial(root) {
    if (!root || root.dataset.yrBbeReady === 'true') return;
    root.dataset.yrBbeReady = 'true';

    var bar = root.querySelector('[data-yr-bbe-offer-bar]');
    var spacer = root.querySelector('[data-yr-bbe-offer-spacer]');
    var countdown = root.querySelector('[data-yr-bbe-countdown]');
    var rail = root.querySelector('[data-yr-bbe-review-rail]');
    var previous = root.querySelector('[data-yr-bbe-review-prev]');
    var next = root.querySelector('[data-yr-bbe-review-next]');

    function sizeOfferSpacer() {
      if (bar && spacer) spacer.style.height = bar.offsetHeight + 'px';
    }

    function updateCountdown() {
      if (countdown) countdown.textContent = countdownLabel(secondsToLondonMidnight(new Date()));
      sizeOfferSpacer();
    }

    function moveReviews(direction) {
      if (!rail) return;
      rail.scrollBy({ left: direction * Math.round(rail.clientWidth * 0.85), behavior: 'smooth' });
    }

    if (previous) previous.addEventListener('click', function () { moveReviews(-1); });
    if (next) next.addEventListener('click', function () { moveReviews(1); });
    window.addEventListener('resize', sizeOfferSpacer);
    window.addEventListener('load', sizeOfferSpacer);
    updateCountdown();
    if (countdown) setInterval(updateCountdown, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-yr-bbe]').forEach(initAdvertorial);
  }

  global.YoruneAdvertorial = {
    secondsToLondonMidnight: secondsToLondonMidnight,
    initAdvertorial: initAdvertorial
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
}(globalThis));
